import { useCallback } from 'react'
import { getRewardsPoints } from 'src/services/rewardsPoints'
import { Campaign } from 'src/util/enums/Campaign'
import {
  CookieKeyTypeEnum,
  getCookieItem,
  setCookieItem,
} from 'src/util/cookie-domain'
import { useGlobalContext } from '../contextoGlobal'

export const useLivelo = () => {
  const { setReward } = useGlobalContext()

  const createOrUpdateCookie = () => {
    const ADDITIONAL_HOURS = 1
    const expires = new Date()
    expires.setUTCHours(expires.getUTCHours() + ADDITIONAL_HOURS)
    setCookieItem(CookieKeyTypeEnum.campaign, Campaign.LIVELO, {
      expires: expires,
    })
  }

  const isComingFromLivelo = useCallback(
    () => getCookieItem(CookieKeyTypeEnum.campaign) === Campaign.LIVELO,
    []
  )

  const createCookieLivelo = useCallback(() => {
    createOrUpdateCookie()
  }, [])

  const updateCookieLivelo = () => {
    if (isComingFromLivelo()) createOrUpdateCookie()
  }

  const updateLiveloParityData = useCallback(async () => {
    if (!isComingFromLivelo()) return

    const data = await getRewardsPoints(Campaign.LIVELO)

    setReward({
      slug: Campaign.LIVELO,
      points: data.points,
      value: data.value,
    })
  }, [setReward, isComingFromLivelo])

  return {
    createCookieLivelo,
    updateCookieLivelo,
    updateLiveloParityData,
  }
}
